import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import type { AnyRoute } from "@tanstack/react-router";

export const createSettingsRoutes = (parent: AnyRoute) => [
  createRoute({
    getParentRoute: () => parent,
    path: "/settings/payment_type",
    component: lazyRouteComponent(() => import("pages/settings/payment_type")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/settings/payment_discount",
    component: lazyRouteComponent(
      () => import("pages/settings/payment_discount"),
    ),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/settings/notification",
    component: lazyRouteComponent(() => import("pages/settings/notification")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/settings/lang",
    component: lazyRouteComponent(() => import("pages/settings/lang")),
  }),
];
